import React from "react";
import { observer, useLocalStore } from "mobx-react";
import { Grid } from "@mui/material";
import { EOCAsyncSelect } from "../input/EOCAsyncSelect";
import apiCall from "../../scripts/apiCall";

/**
 *
 * @param {Object} value {SalesOrganizationName,SalesOrganizationID}
 * @returns "{value,label,SalesOrganizationName,SalesOrganizationID}"
 */

const SAPSalesOrgPicker = ({
  title,
  value,
  required,
  updatefunc,
  multi = false,
  isCreatable = false,
  filter = "",
}) => {
  const getData = (input) =>
    new Promise((resolve) => {
      let fetchOptions = {
        method: "POST",
        credentials: "same-origin",

        body: JSON.stringify({
          proj: "Z_GW_PROSPECT_SRV",
          funct: "SalesOrganizationSet",
          parameters: `$format=json`,
        }),
      };
      var sys = window.localStorage.getItem("QUOTEsys");
      let url = `SAPOData${sys}`;
      return apiCall(url, fetchOptions, (json) =>
        resolve(
          json
            .filter((res) => res.SalesOrganizationID.includes(filter))
            .map((result) => ({
              Name: result.SalesOrganizationName,
              Id: result.SalesOrganizationID,
              value: result.SalesOrganizationName,
              label:
                result.SalesOrganizationName +
                " (" +
                result.SalesOrganizationID +
                ")",
            }))
        )
      );
    });

  const lstore = useLocalStore(() => ({
    onChange(newVal, actionMeta) {
      if (newVal !== null) {
        if (multi) {
          if (isCreatable && actionMeta.action === "create-option")
            newVal.forEach((element) => {
              if (element.__isNew__) {
                element.Name = element.label;
                element.Id = "0";
              }
            });
          updatefunc(newVal);
        } else {
          if (newVal.__isNew__) {
            newVal.Name = newVal.label;
            newVal.Id = "0";
          }
          updatefunc(newVal);
        }
      } else {
        updatefunc(null);
      }
    },
  }));

  return (
    <Grid container spacing={0} direction="column">
      <Grid item xs>
        <label>
          {title}
          {required && " *"}
        </label>
      </Grid>
      <Grid item xs>
        <EOCAsyncSelect
          cy={title}
          isMulti={multi}
          loadOptions={getData}
          value={value}
          updateF={lstore.onChange}
          clearAble={isCreatable}
          isCreatable={isCreatable}
          isSearchable={false}
          defaultOptions
        />
      </Grid>
    </Grid>
  );
};

export default observer(SAPSalesOrgPicker);
